<ng-template #content><ng-content /></ng-template>

@if (noLeftSpacing() || noRightSpacing()) {
    <div
        class="mx-5 sm:!mx-20 xl:!mx-auto max-w-[90rem]"
        [class.pl-20]="!noLeftSpacing()"
        [class.pr-20]="!noRightSpacing()"
    >
        <ng-container *ngTemplateOutlet="content" />
    </div>
} @else {
    <div class="mx-5 sm:!mx-20 xl:!mx-auto max-w-7xl">
        <ng-container *ngTemplateOutlet="content" />
    </div>
}
